import { apiRequest } from './client.js';

export interface SurveySummary {
  id: string;
  code: string;
  version: number;
  name: string;
  description: string | null;
  published_at: string | null;
}

export interface SurveyDetail extends SurveySummary {
  schema: unknown;
}

export const surveysApi = {
  list: () => apiRequest<{ templates: SurveySummary[] }>('/api/v1/surveys'),
  get: (code: string, version: number) =>
    apiRequest<SurveyDetail>(`/api/v1/surveys/${code}/versions/${version}`),
};
